'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { DonationTermsList, useDonationTerms } from '@/components/organism/DonationTerms';
interface AgreementSectionProps {
  onNext?: () => void;
  onClose?: () => void;
}
export const AgreementSection = t0 => {
  const $ = _c(10);
  const {
    onNext,
    onClose
  } = t0;
  const terms = useDonationTerms();
  let t1;
  if ($[0] !== terms) {
    t1 = <DonationTermsList {...terms} />;
    $[0] = terms;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== onNext || $[4] !== terms.agreeAll || $[5] !== terms.isAllRequiredAgreed) {
    t2 = terms.isAllRequiredAgreed ? <Button className="w-full" onClick={() => {
      onNext?.();
      onClose?.();
    }}>기부하기</Button> : <Button theme="sub-fill" className="w-full" onClick={terms.agreeAll}>모두 동의하기</Button>;
    $[2] = onClose;
    $[3] = onNext;
    $[4] = terms.agreeAll;
    $[5] = terms.isAllRequiredAgreed;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="flex flex-col gap-32 mobile-tablet:gap-24">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};